export const blockIconsAndroidDvrNew = (
	<span className='material-symbols-outlined'>dvr</span>
);
